import React from 'react';
import moment from 'moment';
import pad from 'pad';
import utils from '../../utils/utils.functions';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const colummnsPagos = () => {
  return [
    {
      name: 'Codigo',
      selector: 'id',
      sortable: true,
      grow: 0,
      cell: (row) => (
        pad(5,row.id,'0')
      )
    },
    {
      name: 'Descripción',
      selector: 'observation',
      sortable: true,
      width: '40%',
    },
    {
      name: 'Vence',
      sortable: true,
      cell: (row) => (
        moment(row.date_expire_payment).format('DD/MM/YYYY')
      )
    },
    {
      name: 'Monto',
      selector: 'total_amount',
      sortable: true,
      cell: row => (
        utils.formatMoney(row.total_amount)
      )
    },
    {
      name: 'Estado',
      selector: 'status',
      sortable: true,
      cell: row => (
        <div style={{ color: row.status === 0 ? 'red' : row.status === 1 ? 'green' : row.status === 2 ? 'orange' : 'black' }}>
          {row.status === 0 ? 'Pendiente' : row.status === 1 ? `Pagado ${moment(row.date_ready_payment).format('DD/MM/YYYY')}` : row.status === 2 ? 'En confirmación de pago' : null }
        </div>
      )
    },
    /*{
      name: 'Acciones',
      grow: 0,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button disabled={row.status ? true : false} className="btnx btnx-warn icon-table">
            Pagar
          </button>
        </div>
      )
    }*/
  ];
}


const table = {
  customStyles,
  colummnsPagos,
}

export default table;